import { Box, useTheme } from '@hover/blueprint';
import React from 'react';

import { DetailsContactInfo } from './DetailsContactInfo';
import { DetailsHeading } from './DetailsHeading';
import { DetailsLinkOut } from './DetailsLinkOut';

type ContactUser = {
  email?: string;
  name?: string;
  phone?: string;
};

export interface DetailProps {
  createdAt?: string;
  contactUser?: ContactUser;
  ctaPath: string;
}

export const Details = ({
  createdAt,
  contactUser = {},
  ctaPath,
}: DetailProps) => {
  const { breakpoints } = useTheme();

  return (
    <Box flexDirection={{ base: 'column', tablet: 'row' }}>
      <Box
        alignItems={{ tablet: 'center' }}
        flexDirection="column"
        justifyContent="center"
      >
        <Box
          flexDirection="column"
          gap={{ base: 100, tablet: 200 }}
          maxWidth={{ tablet: breakpoints.width100 }}
          paddingX={{ tablet: 500 }}
        >
          <DetailsHeading createdAt={createdAt} />
          <DetailsContactInfo {...contactUser} />
          <DetailsLinkOut ctaPath={ctaPath} />
        </Box>
      </Box>
    </Box>
  );
};
